import moment from "moment";
import React from "react";
import DataTable from "react-data-table-component";
import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";
import { removeHtmlTags, customTableStylesReport, fallbackIfEmpty } from "utils/Utils";
import styles from "./styles.module.scss";

const Table = ({ dados, loading, actionFilter, totalRecords }) => {
  const columns = [
    {
      name: "Nome do Usuário",
      selector: "Nome do usuário",
      sortable: true,
      center: true,
      wrap: true,
      width: "200px",
      style: { textAlign: "center" },
      cell: (d) => fallbackIfEmpty(d["Nome do usuário"]),
    },
    {
      name: "E-mail",
      selector: "E-mail",
      sortable: true,
      center: true,
      wrap: true,
      width: "250px",
      style: { textAlign: "center" },
      cell: (d) => fallbackIfEmpty(d["E-mail"]),
    },
    {
      name: "Login",
      selector: "Login",
      sortable: true,
      center: true,
      wrap: true,
      width: "250px",
      style: { textAlign: "center" },
      cell: (d) => fallbackIfEmpty(d["Login"]),
    },
    {
      name: "Status do Usuário",
      selector: "Status do Usuário",
      sortable: true,
      center: true,
      wrap: true,
      width: "200px",
      style: { textAlign: "center" },
      cell: (d) => fallbackIfEmpty(d["Status do Usuário"]),
    },
    {
      name: "Cargo",
      selector: "Cargo",
      sortable: true,
      center: true,
      wrap: true,
      width: "200px",
      style: { textAlign: "center" },
      cell: (d) => fallbackIfEmpty(d["Cargo"]),
    },
    {
      name: "Departamento",
      selector: "Departamento",
      sortable: true,
      center: true,
      wrap: true,
      width: "200px",
      style: { textAlign: "center" },
      cell: (d) => fallbackIfEmpty(d["Departamento"]),
    },
    {
      name: "Filial",
      selector: "Filial",
      sortable: true,
      center: true,
      wrap: true,
      width: "200px",
      style: { textAlign: "center" },
      cell: (d) => fallbackIfEmpty(d["Filial"]),
    },
    {
      name: "Treinamento",
      selector: "Treinamento",
      sortable: true,
      center: true,
      wrap: true,
      width: "200px",
      style: { textAlign: "center" },
      cell: (d) => fallbackIfEmpty(d["Treinamento"]),
    },
    {
      name: "Turma",
      selector: "Turma",
      sortable: true,
      center: true,
      wrap: true,
      width: "200px",
      style: { textAlign: "center" },
      cell: (d) => fallbackIfEmpty(d["Turma"]),
    },
    {
      name: "Tipo",
      selector: "Tipo",
      sortable: true,
      center: true,
      wrap: true,
      width: "200px",
      style: { textAlign: "center" },
      cell: (d) => fallbackIfEmpty(d["Tipo"]),
    },
    {
      name: "Título da Avaliação",
      selector: "Título da Avaliação",
      sortable: true,
      center: true,
      wrap: true,
      width: "200px",
      style: { textAlign: "center" },
      cell: (d) => fallbackIfEmpty(d["Título da Avaliação"]),
    },
    {
      name: "Resposta",
      selector: "Resposta",
      sortable: true,
      center: true,
      wrap: true,
      width: "200px",
      style: { textAlign: "center" },
      cell: (d) => fallbackIfEmpty(d["Resposta"]),
    },
    {
      name: "Tipo da Questão",
      selector: "Tipo de questão",
      sortable: true,
      center: true,
      wrap: true,
      width: "200px",
      style: { textAlign: "center" },
      cell: (d) => fallbackIfEmpty(d["Tipo de questão"]),
    },
    {
      name: "Questão",
      selector: "Questão",
      sortable: true,
      center: true,
      wrap: true,
      width: "200px",
      style: { textAlign: "center" },
      cell: (d) => <>{d["Questão"] ? removeHtmlTags(d["Questão"], true) : "-"}</>,
    },
    {
      name: "Resposta",
      selector: "Resposta",
      sortable: true,
      center: true,
      wrap: true,
      width: "200px",
      style: { textAlign: "center" },
      cell: (d) => <>{d.Resposta ? removeHtmlTags(d.Resposta, true) : "-"}</>,
    },
    {
      name: "Acertou a Questão?",
      selector: "Acertou a questão?",
      sortable: true,
      center: true,
      wrap: true,
      width: "200px",
      style: { textAlign: "center" },
      cell: (d) => fallbackIfEmpty(d["Acertou a questão?"]),
    },
    {
      name: "Nota de Corte",
      selector: "Nota de corte",
      sortable: true,
      center: true,
      wrap: true,
      width: "200px",
      style: { textAlign: "center" },
      cell: (d) => fallbackIfEmpty(d["Nota de corte"]),
    },
    {
      name: "Nota Final",
      selector: "Nota final",
      sortable: true,
      center: true,
      wrap: true,
      width: "200px",
      style: { textAlign: "center" },
      cell: (d) => fallbackIfEmpty(d["Nota final"]),
    },
    {
      name: "Nota de Corte Atingida?",
      selector: "Nota de corte atingida?",
      sortable: true,
      center: true,
      wrap: true,
      width: "200px",
      style: { textAlign: "center" },
      cell: (d) => fallbackIfEmpty(d["Nota de corte atingida?"]),
    },
  ];

  const tableData = {
    columns: columns,
    data: dados,
  };

  const paginationComponentOptions = {
    rowsPerPageText: "Questões por página",
    rangeSeparatorText: "de",
  };

  const onChangePage = (page, totalRows) => {
    actionFilter({ offset: --page * dados.length });
  };

  const onChangeRowsPerPage = (limit) => {
    actionFilter({ limit, offset: 0 });
  };

  const loadingComponent = () => {
    return (
      <div className="tela-login-loading">
        <div className="loader-container" style={{ margin: "300px 0" }}>
          <div
            style={{
              position: "initial",
              margin: "initial",
            }}
            className="loader loader-center loader-big"
          ></div>
          <span
            style={{
              marginTop: 10,
              fontSize: 20,
            }}
          >
            Carregando dados...
          </span>
        </div>
      </div>
    );
  };

  return (
    <DataTableExtensions
      filter={false}
      print={false}
      {...tableData}
      exportHeaders={true}
      export={false}
    >
      <DataTable
        columns={columns}
        data={dados}
        className={styles.dataTableFormat}
        customStyles={customTableStylesReport}
        progressPending={loading}
        progressComponent={loadingComponent()}
        noHeader={true}
        noDataComponent="Não foi encontrado nenhum dado"
        onChangePage={onChangePage}
        onChangeRowsPerPage={onChangeRowsPerPage}
        paginationTotalRows={totalRecords}
        paginationComponentOptions={paginationComponentOptions}
        paginationServer
        pagination
      />
    </DataTableExtensions>
  );
};

export default Table;
